import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const ChevronDownRounded = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M17 10L12 15L7 10", stroke: "#CF001D", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
    React.createElement("circle", { cx: "12", cy: "12", r: "11", stroke: "#CF001D", strokeWidth: "2", fill: "none" })), 'ChevronDownRounded', { width: 24, height: 24, viewBox: '0 0 24 24' });
export default ChevronDownRounded;
